/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { TeamUserRoleType } from './TeamUserRoleType.js';
import {
    TeamUserRoleTypeFromJSON,
    TeamUserRoleTypeFromJSONTyped,
    TeamUserRoleTypeToJSON,
} from './TeamUserRoleType.js';

/**
 * 
 * @export
 * @interface AddTeamUserRequest
 */
export interface AddTeamUserRequest {
    /**
     * 
     * @type {TeamUserRoleType}
     * @memberof AddTeamUserRequest
     */
    role?: TeamUserRoleType;
}

/**
 * Check if a given object implements the AddTeamUserRequest interface.
 */
export function instanceOfAddTeamUserRequest(value: object): boolean {
    return true;
}

export function AddTeamUserRequestFromJSON(json: any): AddTeamUserRequest {
    return AddTeamUserRequestFromJSONTyped(json, false);
}

export function AddTeamUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddTeamUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'role': json['role'] == null ? undefined : TeamUserRoleTypeFromJSON(json['role']),
    };
}

export function AddTeamUserRequestToJSON(value?: AddTeamUserRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'role': TeamUserRoleTypeToJSON(value['role']),
    };
}

